import PatientSessions from '../components/Sessions/PatientSessions';

const SessionsPage = () => {
  return <PatientSessions />
};

export default SessionsPage;
